import 'isomorphic-fetch';

export async function fetchLaunchDarklyClientConfig(
  baseUrl?: string,
): Promise<string> {
  const response = await fetch(`${baseUrl}/launchDarklyConfig`);
  if (!response.ok) {
    throw new Error('Failed to fetch Launch Darkly Client API key');
  }
  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  return JSON.parse(decodedString);
}
